module.exports = __webpack_public_path__ + "static/search-86b740e9068d692834a1c40c22fa5ea2.png";